/* globals jQuery */
//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade, Keyboard, A11y, Grid} from 'swiper/modules';

(($) => {

    // TESTIMONIAL SLIDER
    const testimonials = document.querySelectorAll('.testimonial-slider');
    testimonials.forEach((slides) => {

        let slider = slides.querySelector('.js-testimonials');
        let pagination = slides.querySelector('.swiper-pagination')

        new Swiper(slider, {
            modules: [EffectFade,Pagination,A11y],
            loop: false,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            pagination: {
                el: pagination,
                clickable: true,
                type: "bullets",
            }
        });
    });

    // ICON CARDS SLIDER
    const iconCardsSlider = document.querySelectorAll('.icon-cards-slider-wrapper');
    iconCardsSlider.forEach((sides) => {

        let slider = sides.querySelector('.icon-cards-slider');
        let prev = sides.querySelector('.swiper-button-prev');
        let next = sides.querySelector('.swiper-button-next');
        let pagination = sides.querySelector('.swiper-pagination')

        new Swiper(slider, {
            modules: [ Navigation, Pagination, Keyboard, A11y, Grid ],
            slidesPerView: 2,
            grid: {
                rows: 2,
                fill: 'column',
            },
            spaceBetween: 20,
            speed: 1000,
            loop: false,
            keyboard: {
                enabled: true
            },
            pagination: {
                el: pagination,
                clickable: true,
                type: "bullets",
            },
            navigation: {
                prevEl: prev,
                nextEl: next
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
            },
            breakpoints: {
                889: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 20,
                    grid: {
                        rows: 1,
                        fill: "row",
                    },
                },
                1400: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                    spaceBetween: 50,
                    grid: {
                        rows: 1,
                        fill: "row",
                    },
                },
            }
        });
    });

})(jQuery)
